module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'unit-listing' + (_vm.grouping ? ' unit-listing--grouping' : '')
  }, [_c('transition', {
    attrs: {
      "name": "animate-filter"
    }
  }, [(!_vm.expanded) ? _c('div', {
    staticClass: "collapsed",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.isManuallyExpanded = true
      }
    }
  }, [(_vm.grouping) ? _c('div', {
    staticClass: "grouping"
  }, [_vm._v(_vm._s(_vm.grouping))]) : _vm._e(), _vm._v(" "), (!_vm.grouping) ? _c('div', {
    staticClass: "text"
  }, [(_vm.unitCount > 1) ? _c('button', {
    staticClass: "expanding-button"
  }, [_vm._v("Visa alla " + _vm._s(_vm.unitCount) + " boendealternativ")]) : _vm._e(), _vm._v(" "), (_vm.unitCount === 1) ? _c('button', {
    staticClass: "expanding-button"
  }, [_vm._v("Visa " + _vm._s(_vm.unitCount) + " boendealternativ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.grouping) ? _c('div', {
    staticClass: "text"
  }, [(_vm.unitCount > 1) ? _c('button', {
    staticClass: "button small white button-expand"
  }, [_vm._v("Visa alla " + _vm._s(_vm.unitCount) + " boendealternativ "), _c('icon', {
    attrs: {
      "name": "chevron-down-blue"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.unitCount === 1) ? _c('button', {
    staticClass: "button small white button-expand"
  }, [_vm._v("Visa " + _vm._s(_vm.unitCount) + " boendealternativ "), _c('icon', {
    attrs: {
      "name": "chevron-down-blue"
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.grouping) ? _c('div', {
    staticClass: "button-square"
  }, [_c('icon', {
    attrs: {
      "name": "chevron-down-white"
    }
  })], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "animate-filter"
    }
  }, [(_vm.expanded) ? _c('div', {
    staticClass: "expanded"
  }, [(!_vm.$store.state.accomodationsFilter.freeSearch) ? _c('div', {
    staticClass: "header",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.isManuallyExpanded = false
      }
    }
  }, [(_vm.grouping) ? _c('div', {
    staticClass: "grouping"
  }, [_vm._v(_vm._s(_vm.grouping))]) : _vm._e(), _vm._v(" "), (!_vm.grouping) ? _c('div', {
    staticClass: "text"
  }, [_vm._v("Stäng")]) : _vm._e(), _vm._v(" "), (_vm.grouping) ? _c('div', {
    staticClass: "text"
  }, [_c('button', {
    staticClass: "button small white button-expand"
  }, [_vm._v("Stäng "), _c('icon', {
    attrs: {
      "name": "chevron-up-blue"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.grouping) ? _c('div', {
    staticClass: "button-square"
  }, [_c('icon', {
    attrs: {
      "name": "chevron-up"
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('table', [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('span', {
    staticClass: "min-tablet"
  }, [_vm._v("Namn")]), _vm._v(" "), _c('span', {
    staticClass: "max-mobile"
  }, [_vm._v("Boende")])]), _vm._v(" "), _c('th', {
    staticClass: "sortable min-tablet",
    attrs: {
      "scope": "col"
    },
    on: {
      "click": function($event) {
        return _vm.sort('beds')
      }
    }
  }, [_vm._v("\n                Bäddar\n                "), _c('TableSortIndicator', {
    attrs: {
      "current": _vm.isSorted('beds')
    }
  })], 1), _vm._v(" "), _c('th', {
    staticClass: "sortable min-tablet",
    attrs: {
      "scope": "col"
    },
    on: {
      "click": function($event) {
        return _vm.sort('bedrooms')
      }
    }
  }, [_vm._v("\n                Sovrum\n                "), _c('TableSortIndicator', {
    attrs: {
      "current": _vm.isSorted('bedrooms')
    }
  })], 1), _vm._v(" "), _c('th', {
    staticClass: "sortable min-tablet",
    attrs: {
      "scope": "col"
    },
    on: {
      "click": function($event) {
        return _vm.sort('living_area')
      }
    }
  }, [_vm._v("\n                Boarea\n                "), _c('TableSortIndicator', {
    attrs: {
      "current": _vm.isSorted('living_area')
    }
  })], 1), _vm._v(" "), _c('th', {
    staticClass: "sortable min-tablet",
    attrs: {
      "scope": "col"
    },
    on: {
      "click": function($event) {
        return _vm.sort('distance_to_pist')
      }
    }
  }, [_vm._v("\n                Pist\n                "), _c('TableSortIndicator', {
    attrs: {
      "current": _vm.isSorted('distance_to_pist')
    }
  })], 1), _vm._v(" "), _c('th', {
    staticClass: "min-tablet",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Typ")]), _vm._v(" "), _c('th', {
    staticClass: "no-padding min-tablet",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Jämför boende")]), _vm._v(" "), _c('th', {
    staticClass: "min-tablet",
    attrs: {
      "scope": "col"
    }
  })])]), _vm._v(" "), _c('transition-group', {
    staticClass: "animate-pool-list",
    attrs: {
      "name": "animate-pool-list",
      "tag": "tbody"
    }
  }, _vm._l((_vm.sortedUnits), function(unit, index) {
    return _c('tr', {
      key: unit.id,
      staticClass: "animate-pool-list-item",
      class: {
        odd: index % 2
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.openInfo(unit)
        }
      }
    }, [_c('th', {
      staticClass: "wrap unit-title",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v("\n                " + _vm._s((unit.display_name || unit.description_title)) + "\n                "), (unit.subtitle) ? _c('i', [_vm._v(_vm._s(unit.subtitle))]) : _vm._e(), _vm._v(" "), (_vm.$store.state.accomodationsFilter.date.endDate) ? _c('AccomodationUnitsLeft', {
      attrs: {
        "units-total": unit.unit_count,
        "units-left": _vm.getUnitsLeft(unit.id),
        "unit-type": unit.accomodationtype,
        "unit-title": (unit.display_name || unit.description_title),
        "unit-show": (unit.unit_lid <= 0)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.$store.state.accomodationsFilter.date.endDate) ? _c('b', {
      staticClass: "max-mobile"
    }, [_vm._v(_vm._s(_vm._f("currency")(_vm.getPrice(unit.id))))]) : _vm._e()], 1), _vm._v(" "), _c('td', {
      staticClass: "facts max-mobile"
    }, [_c('div', [_c('b', [_vm._v("Sängar: ")]), _vm._v(" " + _vm._s(unit.beds)), (unit.extra_beds) ? _c('span', [_vm._v("+" + _vm._s(unit.extra_beds))]) : _vm._e()]), _vm._v(" "), (unit.living_area) ? _c('div', [_c('b', [_vm._v("Boarea: ")]), _vm._v(_vm._s(unit.living_area) + "m"), _c('sup', [_vm._v("2")])]) : _vm._e(), _vm._v(" "), (unit.distance_to_pist) ? _c('div', [_c('b', [_vm._v("Pist: ")]), _vm._v(" " + _vm._s(unit.distance_to_pist) + "m")]) : _vm._e(), _vm._v(" "), _c('div', [_c('b', [_vm._v("Sovrum: ")]), _vm._v(" " + _vm._s(unit.bedrooms))]), _vm._v(" "), (unit.accomodationtype) ? _c('div', [_c('b', [_vm._v("Typ: ")]), _vm._v(" " + _vm._s(unit.accomodationtype.value))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "min-tablet"
    }, [_vm._v(_vm._s(unit.beds)), (unit.extra_beds) ? _c('span', [_vm._v("+" + _vm._s(unit.extra_beds))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "min-tablet"
    }, [_vm._v(_vm._s(unit.bedrooms))]), _vm._v(" "), _c('td', {
      staticClass: "min-tablet"
    }, [_vm._v(_vm._s(unit.living_area) + "m"), _c('sup', [_vm._v("2")])]), _vm._v(" "), _c('td', {
      staticClass: "min-tablet"
    }, [_vm._v(_vm._s(unit.distance_to_pist ? unit.distance_to_pist + 'm' : ''))]), _vm._v(" "), _c('td', {
      staticClass: "min-tablet"
    }, [_vm._v(_vm._s(unit.accomodationtype ? unit.accomodationtype.value : ''))]), _vm._v(" "), _c('td', {
      staticClass: "min-tablet"
    }, [_c('div', {
      class: {
        'favorite-icon-wrapper': true,
        'active': _vm.isFavorite(unit.id)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleFavorite(unit.id)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "actions"
    }, [_c('div', [(!_vm.$store.state.accomodationsFilter.date.endDate) ? _c('button', {
      staticClass: "outline-button price-info-bt",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.openPriceList(unit)
        }
      }
    }, [_vm._v("Prislista")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.accomodationsFilter.date.endDate) ? _c('b', {
      staticClass: "the-price",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.openPriceList(unit)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("currency")(_vm.getPrice(unit.id))))]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "outline-button price-info-bt",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.openInfo(unit)
        }
      }
    }, [_vm._v(_vm._s((_vm.$store.state.accomodationsFilter.date.endDate ? 'Info/boka' : 'Info')))]), _vm._v(" "), _c('div', {
      class: {
        'favorite-icon-wrapper': true,
        'active': _vm.isFavorite(unit.id),
          'max-mobile': true
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleFavorite(unit.id)
        }
      }
    })])])])
  }), 0)], 1)])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9fbfdca4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/Accomodation/List/AccomodationsListUnitsList.vue
// module id = 990
// module chunks = 0